import "core-js/modules/es.array.push.js";
import { ref } from "vue";
import { delay } from "@/common/utils";
import { ElMessage } from "element-plus";
export default {
  name: "ImageSplit",
  props: {
    img: String
  },
  setup(props, {
    emit
  }) {
    const loading = ref(false);
    const imgList = ref([]);
    //行数
    const rows = ref(2);
    //列数
    const columns = ref(2);

    //拆分图片
    const split = async () => {
      loading.value = true;
      await delay(300);
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = props.img;
      img.onload = function () {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d", {
          willReadFrequently: true
        });
        ctx.drawImage(img, img.width, img.height);
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0, img.width, img.height);
        imgList.value = getList(ctx);
        loading.value = false;
      };
      img.onerror = e => {
        loading.value = false;
        ElMessage.error("切图失败");
        emit("error");
      };
    };

    //得到切割后的图片列表
    const getList = ctx => {
      let destWidth = ctx.canvas.width / columns.value;
      let destHeight = ctx.canvas.height / rows.value;
      let list = [];
      for (let i = 0; i < rows.value; i++) {
        let listOne = [];
        for (let k = 0; k < columns.value; k++) {
          let url = getPart(ctx, k * destWidth, i * destHeight, destWidth, destHeight);
          listOne.push(url);
        }
        list.push(listOne);
      }
      return list;
    };
    //得到canvas的指定部分
    const getPart = (ctx, x, y, w, h) => {
      let canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      let data = ctx.getImageData(x, y, w, h);
      let context = canvas.getContext("2d");
      context.putImageData(data, 0, 0);
      return canvas.toDataURL("image/png", 1);
    };
    return {
      imgList,
      rows,
      loading,
      columns,
      split
    };
  }
};